import { makeAutoObservable } from "mobx";
import { SearchObject } from "app/common/Model/SearchObject";
import {
  pagingCustomerSource,
  getCustomerSourceById,
  saveCustomerSource,
  deleteCustomerSource,
  importCustomerSourceExcel,
  syncCustomerSource,
} from "app/services/CustomerSourceService";
import { CustomerSource } from "app/common/Model/CustomerSource";
import { checkSearchObject } from "app/common/LocalFunction";
import { toast } from "react-toastify";
import { downloadTemplateCustomerSource } from "app/services/ImportExcelService";

export default class CustomerSourceStore {
  listAllCustomerSource = [];
  searchCustomerSource = new SearchObject();
  pageCustomerSource = null;
  selectedCustomerSource = null;
  openFormCreateOrEdit = false;
  openConfirmDeleteCustomerSource = false;
  openImportExcel = false;

  constructor() {
    makeAutoObservable(this);
  }

  pagingCustomerSource = () => {
    pagingCustomerSource(this.searchCustomerSource)
      .then(({ data }) => {
        this.pageCustomerSource = data;
      })
      .catch((error) => {
        console.error(error);
        toast.error("Lấy dữ liệu có lỗi");
      });
  };

  handleChangeFormSearch = (searchCustomerSource) => {
    const updatedSearch = {
      ...searchCustomerSource,
      groupId: searchCustomerSource.groupId?.id || null,
    };
    this.searchCustomerSource = checkSearchObject(
      this.searchCustomerSource,
      updatedSearch
    );
    this.pagingCustomerSource();
  };

  hanleSyncCustomerSource = () => {
    syncCustomerSource()
      .then(({ data }) => {
        toast.success("Đồng bộ thành công");
      })
      .catch((error) => {
        console.error(error);
        toast.error("Đồng bộ dữ liệu có lỗi");
      });
  };

  handleOpenFormCreateOrEdit = (customerSourceId) => {
    if (Boolean(customerSourceId)) {
      getCustomerSourceById(customerSourceId)
        .then(({ data }) => {
          const customerSource = data || {};
          if (!Array.isArray(customerSource.positions)) {
            customerSource.positions = [];
          }
          this.selectedCustomerSource = customerSource;
          this.openFormCreateOrEdit = true;
        })
        .catch((error) => {
          console.error(error);
          toast.error("Lấy dữ liệu có lỗi");
        });
    } else {
      this.selectedCustomerSource = new CustomerSource();
      this.openFormCreateOrEdit = true;
    }
  };

  handleOpenImportExcel = () => {
    this.openImportExcel = true;
  };
  handleCloseImportExcel = () => {
    this.openImportExcel = false;
  };

  saveImportExcelCustomer = (file) => {
    importCustomerSourceExcel(file)
      .then(() => {
        toast.success("Nhập excel thành công");
        this.searchCustomerSource = {
          ...this.searchCustomerSource,
          pageIndex: 1,
        };
        this.pagingCustomerSource();
        this.openImportExcel = false;
      })
      .catch(() => {
        toast.error("Nhập excel thất bại");
      })
      .finally(() => {
        this.handleClosePopup();
      });
  };

  saveCustomerSource = (customerSource) => {
    return saveCustomerSource(customerSource)
      .then(() => {
        this.selectedCustomerSource = null;
        toast.success("Lưu bản ghi thành công!");
        this.handleClosePopup();
        this.pagingCustomerSource();
      })
      .catch((error) => {
        console.error(error);
        toast.error("Lưu thông tin nhóm nguồn Khách có lỗi");
      });
  };

  handleDeleteCustomerSource = (customerSource) => {
    this.selectedCustomerSource = { id: customerSource?.id };
    this.openConfirmDeleteCustomerSource = true;
  };

  handleConfirmDeleteCustomerSource = () =>
    deleteCustomerSource(this?.selectedCustomerSource?.id)
      .then(() => {
        if (
          this.searchCustomerSource.pageIndex > 1 &&
          this.pageCustomerSource.content.length === 1
        ) {
          this.searchCustomerSource.pageIndex -= 1;
        }
        toast.success("Xóa nguồn Khách thành công!");
        this.handleClosePopup();
        this.pagingCustomerSource();
      })
      .catch((err) => {
        console.error(err);
        toast.error("Xóa nguồn Khách có lỗi");
      });

  handleClosePopup = () => {
    this.openFormCreateOrEdit = false;
    this.openConfirmDeleteCustomerSource = false;
    this.openImportExcel = false;
  };

  handleDownloadExcelTemplate = async () => {
    try {
      const response = await downloadTemplateCustomerSource();

      if (response.status === 200) {
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", "NGUON_CHI_TIET.xlsx");
        document.body.appendChild(link);
        link.click();
        link.parentNode.removeChild(link);
      }
    } catch (error) {
      console.error("Error downloading template:", error);
    }
  };

  resetStore = () => {
    this.searchCustomerSource = new SearchObject();
    this.pageCustomerSource = null;
    this.selectedCustomerSource = null;
    this.openFormCreateOrEdit = false;
    this.openConfirmDeleteCustomerSource = false;
  };
}
